import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  useDisclosure,
  Flex,
  Text,
} from '@chakra-ui/react'
import * as T from '../../../../components/Table'
import { infoColor } from '../../../../utils/infoColorFunil'
import { usePdfGeneratorNew } from '../../../../hooks/usePdfGenerator'

export const MaisInformacoes = ({ data }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { generatePDF } = usePdfGeneratorNew()

  const summary = data.reduce(
    (acc, item) => {
      const funil = item.funil_vendas
      const vendedor = item.nome_vendedor

      if (!acc.funil[funil]) {
        acc.funil[funil] = { quantidade: 0, valor_total: 0 }
      }

      if (!acc.vendedor[vendedor]) {
        acc.vendedor[vendedor] = { quantidade_pedido: 0, valor_total: 0 }
      }

      acc.funil[funil].quantidade++
      acc.funil[funil].valor_total += parseFloat(item.valor_total)

      acc.vendedor[vendedor].quantidade_pedido++
      acc.vendedor[vendedor].valor_total += parseFloat(item.valor_total)

      return acc
    },
    { funil: {}, vendedor: {} }
  )

  function handleDownloadPdf() {
    const funilHeadData = ['Funil', 'Quantidade', 'Valor Total']
    const funilBodyData = Object.entries(summary.funil).map(([funil, valores]) => [funil, valores.quantidade, valores.valor_total.toFixed(2)])

    generatePDF(funilHeadData, funilBodyData, 'Relatório de Funil', summary)

    const vendedorHeadData = ['Vendedor', 'Quantidade Pedidos', 'Valor Total']
    const vendedorBodyData = Object.entries(summary.vendedor).map(([vendedor, valores]) => [
      vendedor,
      valores.quantidade_pedido,
      valores.valor_total.toFixed(2),
    ])

    generatePDF(vendedorHeadData, vendedorBodyData, 'Relatório de Vendedor', summary)
  }

  return (
    <>
      <Button onClick={onOpen} variant="link" ml="auto" mt={5} mr={5}>
        + Mais informações
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Outras informações</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent="space-between" alignItems="start" gap={4}>
              <T.Table>
                <T.Thead>
                  <T.Tr>
                    <T.Th>Funil de vendas</T.Th>
                    <T.Th>Quantidade</T.Th>
                    <T.Th>Valor total</T.Th>
                  </T.Tr>
                </T.Thead>
                <T.Tbody>
                  {Object.entries(summary.funil).map(([funil, { quantidade, valor_total }]) => (
                    <T.Tr key={funil}>
                      <T.Td py={2} bg={`${infoColor[funil]}!important` || 'gray.100'} color="white">
                        <Text fontWeight="bold">{funil}</Text>
                      </T.Td>
                      <T.Td py={2}>{quantidade}</T.Td>
                      <T.Td py={2}>
                        <Text fontWeight="bold">{valor_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Text>
                      </T.Td>
                    </T.Tr>
                  ))}
                </T.Tbody>
              </T.Table>
              <T.Table>
                <T.Thead>
                  <T.Tr>
                    <T.Th>Vendedor</T.Th>
                    <T.Th>Quantidade de pedidos</T.Th>
                    <T.Th>Valor total</T.Th>
                  </T.Tr>
                </T.Thead>
                <T.Tbody>
                  {Object.entries(summary.vendedor).map(([vendedor, { quantidade_pedido, valor_total }]) => (
                    <T.Tr key={vendedor}>
                      <T.Td py={2}>{vendedor}</T.Td>
                      <T.Td py={2}>{quantidade_pedido}</T.Td>
                      <T.Td py={2}>{valor_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</T.Td>
                    </T.Tr>
                  ))}
                </T.Tbody>
              </T.Table>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button variant="ghost" onClick={handleDownloadPdf}>
              Baixar PDF
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
